{
  "models": {
    "alert": "Alert",
    "alert_plural": "Alerts",
    "analytics": "Analytics",
    "analytics_plural": "Analytics",
    "node": "Device",
    "node_plural": "Devices",
    "thiamis": "Thiamis",
    "thiamis_plural": "Thiamis",
    "device": "Device",
    "device_plural": "Devices",
    "dashboard": "Dashboard",
    "dashboard_plural": "Dashboard",
    "dashboard_create": "Create Dashboard",
    "monitor": "Monitor",
    "widget": "Widget",
    "widget_plural": "Widgets",
    "user": "User",
    "user_plural": "Users",
    "user_invitation": "Invitation",
    "user_invitation_plural": "Invitations",
    "data_point": "Data Point",
    "data_point_plural": "Data Points",
    "parameter": "Parameter",
    "parameter_plural": "Parameters",
    "node_widget": "Device",
    "node_widget_create": "Create Device Widget",
    "node_widget_update": "Update Device Widget",
    "node_widget_plural": "Device Widgets",
    "chart_widget": "Chart",
    "chart_widget_create": "Create Chart Widget",
    "chart_widget_update": "Update Chart Widget",
    "chart_widget_plural": "Chart Widgets",
    "text_widget": "Text",
    "text_widget_create": "Create Text Widget",
    "text_widget_update": "Update Text Widget",
    "text_widget_plural": "Text Widgets",
    "map_widget": "Map",
    "map_widget_create": "Create Map Widget",
    "map_widget_update": "Update Map Widget",
    "map_widget_plural": "Map Widgets",
    "heatmap_widget": "Parameter",
    "heatmap_widget_create": "Create Parameter Widget",
    "heatmap_widget_update": "Update Parameter Widget",
    "heatmap_widget_plural": "Parameter Widgets",
    "wind_rose_widget": "Wind Rose",
    "wind_rose_widget_create": "Create Wind Rose Widget",
    "wind_rose_widget_update": "Update Wind Rose Widget",
    "wind_rose_widget_plural": "Wind Rose Widgets",
    "connectivity_widget": "Connectivity",
    "connectivity_widget_create": "Create Connectivity Widget",
    "connectivity_widget_update": "Update Connectivity Widget",
    "connectivity_widget_plural": "Connectivity Widgets",
    "distribution_widget": "Distribution",
    "distribution_widget_create": "Create Distribution Widget",
    "distribution_widget_update": "Update Distribution Widget",
    "distribution_widget_plural": "Distribution Widgets",
    "table_widget": "Table",
    "table_widget_plural": "Table Widgets",
    "blocks_widget": "Block",
    "blocks_widget_create": "Create Block Widget",
    "blocks_widget_update": "Update Block Widget",
    "blocks_widget_plural": "Block Widgets",
    "twitter_widget": "Twitter",
    "twitter_widget_plural": "Twitter Widgets",
    "airthinx_widget_plural": "Parameter Widgets",
    "sensors_widget": "Sensors",
    "organization": "Organization",
    "organization_plural": "Organizations",
    "partnership": "Partnership",
    "partnership_plural": "Partnerships",
    "partnership_invitation": "Partnership Invitation",
    "partnership_invitation_plural": "Partnership Invitations",
    "message": "Message",
    "message_plural": "Messages",
    "address": "Address",
    "address_plural": "Addresss",
    "contact_info": "Contact Info",
    "contact_info_plural": "Contact Infos",
    "map": "Map",
    "map_plural": "Map",
    "file": "File",
    "file_plural": "Files",
    "formation_request": "Organization Request",
    "formation_request_plural": "Organization Requests",
    "archive": "File",
    "user_file_plural": "Files",
    "firmware": "Firmware",
    "firmware_plural": "Firmware",
    "certificate": "Certificate",
    "certificate_plural": "Certificates",
    "api": "API",
    "api_plural": "API",
    "webhook": "Webhook",
    "webhook_plural": "Webhooks",
    "permission": "Permission",
    "permission_plural": "Permissions"
  },
  "attributes": {
    "alert": {
      "name": "Name",
      "description": "Message",
      "last_triggered_ts": "Last Triggered",
      "organization_id": "Owner",
      "level": "Notification Level",
      "rules": "Conditions",
      "nodes": "Nodes",
      "subscriptions": "Subscribers",
      "reactivation_time_ms": "Alert Reactivation",
      "activation_ts": "Activation Date",
      "deactivation_ts": "Deactivation Date",
      "status": "Status",
      "notification_level": "Notification Level",
      "notification_method": "Notification Method"
    },
    "alert_rule": {
      "sensor": "Sensor",
      "node": "Device",
      "name": "Parameter",
      "func": "Comparison operator",
      "value": "Value"
    },
    "api": {
      "organization_id": "Organization",
      "created_at": "Created",
      "device_scope": "Device Scope",
      "last_used_at": "Last Used",
      "user_id": "Created By",
      "requests": "Requests",
      "_id": "Key"
    },
    "webhook": {
      "url": "URL",
      "auth": "Auth",
      "nodes": "Nodes",
      "type": "Type"
    },
    "node": {
      "serial": "S/N",
      "name": "Name",
      "timezone": "Timezone",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "description": "Description",
      "reporting_interval": "Online Interval",
      "is_public": "Published",
      "leased_to": "Leased to",
      "shared_to": "Shared to",
      "calibration_date": "Calibration Date",
      "verification_date": "Date Tested",
      "calibration_certificate": "Calibration Certificate",
      "performance_verification": "Performance Certificate",
      "type": "Type",
      "status": "Status"
    },
    "firmware": {
      "version": "Firmware",
      "thiamis": "Thiamis",
      "channel": "Channel",
      "serials": "Serials",
      "status": "Status",
      "current_units": "Current Units",
      "pending_units": "Pending Units"
    },
    "calibration": {
      "serial": "Serial",
      "status": "Status",
      "ready": "Ready",
      "timestamp": "Last Run",
      "applied_ts": "Last Run (UTC)",
      "from_ts": "Window From (UTC)",
      "to_ts": "Window To (UTC)",
      "reference_value": "Reference Device",
      "metrics": "Metrics",
      "data": "Device Data",
      "reference_samples": "Reference Data",
      "samples_summary": "%{cnt}/%{required_cnt} samples · spread %{diff}/%{required_diff}",
      "setting": "Device Setting",
      "parameters": "Sensors",
      "passed": "Passed",
      "failed": "Failed",
      "statuses": {
        "ok": "Passed",
        "fail": "Failed",
        "not_run": "Not Run"
      },
      "errors": {
        "title": "Issue",
        "reference_label": "Reference",
        "device_label": "Device",
        "samples": "%{label} samples %{value} (need ≥ %{required})",
        "range": "%{label} range %{value} (need ≥ %{required})",
        "metric": "%{metric} %{value} (need %{comparator} %{required})",
        "reasons": {
          "no_data": "Not enough valid data in the selected time range",
          "accuracy": "Calibration accuracy outside the acceptable range",
          "reference": "Reference instrument had insufficient data — every device in this run is affected"
        },
        "buckets": {
          "offline": "device offline for the whole window",
          "gap": "device dropped off and came back",
          "sparse": "device reported sparsely"
        }
      }
    },
    "common": {
      "created_at": "Date Created"
    },
    "thiamis": {
      "serial": "S/N",
      "firmware": "F/W",
      "firmware_channel": "F/W Channel",
      "mac_address": "MAC",
      "imei": "IMEI",
      "iccid": "ICCID",
      "imsi": "IMSI",
      "wifi_bssid": "WiFi BSSID",
      "wifi_network": "WiFi Network",
      "gsm_network": "Network",
      "battery": "Battery",
      "wifi_ssid": "WiFi SSID",
      "wifi_password": "WiFi Password",
      "enable_battery": "Batt. Voltage",
      "enable_led": "Status",
      "led_aq": "Visual Alerts",
      "public_link": "Public Link",
      "enable_temperature": "Temperature",
      "dfs": "DFS",
      "speed": "Speed",
      "pm_config": "Particle Counters",
      "pm_bin_counters": "Particle Bin Counters",
      "voc_unit": "VOC Unit",
      "extensions": "Profile",
      "automation_devices": "Connected Devices",
      "automation": "AQMS",
      "bluetooth_share": "Share Bluetooth",
      "enable_pressure": "Pressure",
      "enable_humidity": "Humidity",
      "enable_gps": "GPS",
      "debug_level": "Debug Level",
      "debug_tags": "Debug Tags",
      "rtu_status": "RTU Status",
      "organization_id": "Owner",
      "location": "Location",
      "name": "Name",
      "model": "Model",
      "interval": "Online Interval",
      "timezone": "Timezone",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "description": "Description",
      "reporting_interval": "Online Interval",
      "is_public": "Published",
      "leased_to_org": "Leased to Organization",
      "shared_to_orgs": "Shared to Organizations",
      "shared_to_users": "Shared to Users",
      "type": "Type",
      "status": "Status",
      "temp_f": "Temperature in °F",
      "settings_endpoint": "Change Endpoint",
      "settings_run_action": "Run Action",
      "settings_endpoint_default": "Default",
      "settings_endpoint_custom": "Custom",
      "scheduler": "Scheduler"
    },
    "dashboard": {
      "title": "Title",
      "name": "Name",
      "dashboard_name": "Name",
      "description": "Description",
      "organization": "Organization"
    },
    "report": {
      "name": "Name",
      "description": "Description",
      "standard": "Standard",
      "type": "Report Type",
      "working_hours": "Working hours",
      "working_days": "Working days",
      "include_logo": "Show Organization Logo",
      "include_logo_missing_tooltip": "Organization logo is missing. Please upload it on the Organization Edit page.",
      "include_summary": "Include Summary by Noesis",
      "start_of_the_week": "Start of the week",
      "date_range": "Reporting period",
      "run_type": "Run Type",
      "frequency": "Frequency",
      "subscribers": "Subscribers",
      "run_type_once": "Once",
      "run_type_scheduled": "Scheduled",
      "types": {
        "air_quality": "Air Quality",
        "air_quality_crp": "Cabin Air Quality",
        "perimeter_monitor": "Perimeter Monitoring",
        "aethair_cms_2567": "Aethair CMS-2567"
      },
      "standards": {
        "airthinx-default": "Aethair Blue",
        "airthinx-cms-2567": "Aethair CMS-2567",
        "air-quality-custom": "Custom",
        "airthinx-well-v2": "WELL V2",
        "aethair-crp-default": "Aethair Cabin",
        "perimeter-custom": "Custom",
        "nys-der-10": "NYS DER-10 (CAMP)",
        "nj-dep-pam": "NJDEP PAM"
      },
      "node_ids": "Devices"
    },
    "sensor": {
      "name": "Sensor Name",
      "vendor": "Vendor",
      "sensor_type": "Sensor",
      "com_port": "Com Port",
      "com_type": "Com Type",
      "address": "Address",
      "serial": "S/N",
      "model": "Model",
      "status": "Status",
      "measurements": "Measurements"
    },
    "node_widget": {
      "selected_data_point_ids": "Included",
      "filtered_data_point_ids": "Excluded"
    },
    "chart_widget": {
      "selected_data_point_ids": "Selected Data Points"
    },
    "heatmap_widget": {
      "selected_data_point_id": "Parameter"
    },
    "table_widget": {
      "timestamp": "Time"
    },
    "data_point": {
      "name": "Name",
      "last_value": "Value",
      "last_unit": "Unit"
    },
    "organization": {
      "name": "Name",
      "fullname": "Organization Name",
      "member_count": "Members",
      "node_count": "Nodes",
      "contact": "Contact",
      "location": "Location",
      "created_at": "Registered",
      "billing_same_as_shipping": "Use the same address for billing",
      "website": "Company Website",
      "industry": "Industry",
      "contact_first_name": "First Name",
      "contact_last_name": "Last Name",
      "contact_job_title": "Job Title",
      "contact_email": "Email",
      "contact_phone": "Phone"
    },
    "partner_organization": {
      "name": "Partner organization"
    },
    "partnership": {
      "org1_name": "Organization",
      "org2_name": "Partner",
      "org2_location": "Location",
      "org2_contact": "Contact",
      "access": "Access"
    },
    "partnership_invitation": {
      "email": "Email",
      "acceptance_state": "State",
      "inviting_organization_name": "Inviting Organization",
      "created_at": "Created"
    },
    "user": {
      "old_password": "Old Password",
      "name": "Name",
      "given_name": "First Name",
      "family_name": "Last Name",
      "email": "Email",
      "mobile": "Mobile Phone",
      "phone": "Phone",
      "temp_units": "Temperature Units",
      "temp_units_both": "Both",
      "password": "Password",
      "password_confirmation": "Confirm Password",
      "new_password": "New Password",
      "new_password_confirmation": "Confirm New Password",
      "locale": "Language",
      "status": "Status",
      "role": "Role",
      "contact": "Contact",
      "company_location": "Company Location",
      "last_login": "Last Login",
      "active": "Last Activity",
      "address_country": "Country",
      "address_zip_code": "Zip Code",
      "address_city": "City",
      "address_state": "State",
      "address_street": "Street",
      "job_title": "Job Title",
      "organization_level": "Organization Level"
    },
    "message": {
      "subject": "Message",
      "body": "Content",
      "type": "Type",
      "time": "Time"
    },
    "user_invitation": {
      "email": "Email",
      "organization": "Organization",
      "role": "User Role",
      "acceptance_state": "Status"
    },
    "address": {
      "shipping_address": "Shipping Address",
      "billing_address": "Billing Address",
      "shipping_address_street": "Street Address",
      "shipping_address_city": "City",
      "address_state": "State",
      "shipping_address_state": "State",
      "shipping_address_country": "Country",
      "shipping_address_zip_code": "Zip Code",
      "billing_address_street": "Street Address",
      "billing_address_city": "City",
      "billing_address_state": "State",
      "billing_address_country": "Country",
      "billing_address_zip_code": "Zip Code"
    },
    "contact_info": {
      "contact_first_name": "First Name",
      "contact_last_name": "Last Name",
      "contact_phone": "Phone",
      "contact_email": "Email",
      "contact_company": "Company",
      "contact_website": "Website",
      "contact_industry": "Industry"
    },
    "formation_request": {
      "name": "Organization Name",
      "requester_organization_id": "Requester Organization",
      "shipping_address_street": "Street Address",
      "shipping_address_city": "City",
      "shipping_address_zip_code": "Zip Code",
      "shipping_address_state": "State",
      "shipping_address_country": "Country",
      "billing_address_street": "Street Address",
      "billing_address_city": "City",
      "billing_address_zip_code": "Zip Code",
      "billing_address_state": "State",
      "billing_address_country": "Country",
      "billing_same_as_shipping": "use the same address for billing",
      "contact": "Contact",
      "location": "Location",
      "created_at": "Created",
      "contact_first_name": "Contact First Name",
      "contact_last_name": "Contact Last Name",
      "contact_email": "Contact Email",
      "industry": "Industry",
      "acceptance_state": "State"
    },
    "archive": {
      "serial": "Serial",
      "date_to": "Date To",
      "date_from": "Date From",
      "uploaded_by": "Uploaded By",
      "created_at": "Created"
    }
  },
  "cms_2567": {
    "aecc_categories": {
      "title": "AECC Compliance Categories",
      "add_category": "Add AECC Category",
      "all_added": "All available AECC categories have been added",
      "subcategories_title": "Subcategories"
    }
  },
  "validation": {
    "backbone": {
      "errors": {
        "required": "{0} is required",
        "acceptance": "{0} must be accepted",
        "min": "{0} must be greater than or equal to {1}",
        "max": "{0} must be less than or equal to {1}",
        "range": "{0} must be between {1} and {2}",
        "length": "{0} must be {1} characters",
        "minLength": "{0} must be at least {1} characters",
        "maxLength": "{0} must be at most {1} characters",
        "rangeLength": "{0} must be between {1} and {2} characters",
        "oneOf": "{0} must be one of: {1}",
        "equalTo": "{0} must be the same as {1}",
        "digits": "{0} must only contain digits",
        "number": "{0} must be a number",
        "email": "{0} must be a valid email",
        "url": "{0} must be a valid url",
        "inlinePattern": "{0} is invalid"
      }
    },
    "errors": {
      "required": "this field is required",
      "email": "has to be a valid email",
      "phone": "has to be a valid phone number",
      "min": "%{attr} should be at least %{minLength} characters",
      "equalTo": "%{attr1} must be the same as %{attr2}",
      "models": {
        "organization": {
          "attribute": {
            "is_rental": "has to be rental"
          }
        },
        "user": {
          "attributes": {
            "phone": "invalid phone number",
            "phone_with_example": "invalid number, ex: %{example}",
            "old_password": "Sorry old password doesn't match"
          }
        }
      }
    }
  }
}